import { ReactElement, isValidElement } from "react"
import {
  PdfGeneratorHeaderFooterSlot,
  PdfGeneratorPageRegion
} from "../types"

export type PdfGeneratorNormalizedRunningSlot = {
  content: ReactElement
  runningId: string
  region: PdfGeneratorPageRegion
  marginSize: string
}

const DEFAULT_HEADER_RUNNING_ID = "pdf-generator-header"
const DEFAULT_FOOTER_RUNNING_ID = "pdf-generator-footer"
const DEFAULT_MARGIN_SIZE = "0.75in"

export const normalizePdfHeaderSlot = (
  header?: ReactElement | PdfGeneratorHeaderFooterSlot
): PdfGeneratorNormalizedRunningSlot | null => {
  if (!header) {
    return null
  }

  if (isValidElement(header)) {
    return {
      content: header,
      runningId: DEFAULT_HEADER_RUNNING_ID,
      region: "top-center",
      marginSize: DEFAULT_MARGIN_SIZE
    }
  }

  return {
    content: header.content,
    runningId: header.runningId ?? DEFAULT_HEADER_RUNNING_ID,
    region: header.region ?? "top-center",
    marginSize: header.marginSize ?? DEFAULT_MARGIN_SIZE
  }
}

export const normalizePdfFooterSlot = (
  footer?: ReactElement | PdfGeneratorHeaderFooterSlot
): PdfGeneratorNormalizedRunningSlot | null => {
  if (!footer) {
    return null
  }

  if (isValidElement(footer)) {
    return {
      content: footer,
      runningId: DEFAULT_FOOTER_RUNNING_ID,
      region: "bottom-center",
      marginSize: DEFAULT_MARGIN_SIZE
    }
  }

  return {
    content: footer.content,
    runningId: footer.runningId ?? DEFAULT_FOOTER_RUNNING_ID,
    region: footer.region ?? "bottom-center",
    marginSize: footer.marginSize ?? DEFAULT_MARGIN_SIZE
  }
}
